import React from "react"
import { FaRegCalendarCheck, FaRegFlag, FaRegCalendarAlt,FaRegCalendarTimes,FaHome, FaRegBookmark,FaTags, FaClipboardList, FaCheck, FaAddressCard, FaRegClock, FaCodeBranch, FaPlusCircle, FaUser, FaInfoCircle, FaEnvelope, FaMobileAlt, FaArrowAltCircleLeft, FaWindowClose, FaMailBulk, FaCheckDouble, FaCalendarCheck, FaCalendarTimes, FaCalendarMinus, FaCalendarPlus, FaEdgeLegacy, FaArrowAltCircleRight, FaBoxOpen, FaMarker, FaWifi} from "react-icons/fa"
import { useDataNavbarContext } from "../context/DataNavbarContext"
//window.sessionStorage.setItem("user", JSON.stringify(localStorage.getItem('user')));
const user = JSON.parse(sessionStorage.getItem('user'))
let size = 15
const Metricas = ({ badgeText }) => {
  let text = ""
  const navbarCtx = useDataNavbarContext()
  switch (badgeText) {
    case 'Tokens':
      text = navbarCtx?.totalNavbarTokens
      break;
    default:
      text = "Pendiente"
      break;
  }

  return (
    <div className="menu-badge">
      {text}
    </div>
  )
}

const navigation = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "token",
    title: "Listado Token",
    type: "item",
    icon: <FaMobileAlt size={size} />,
    badge: "warning",
    badgeText: <Metricas badgeText="Tokens" />,
    permissions: ["admin", "editor"],
    navLink: "/listado-tokens"
  },
  {
    id: "usuarios",
    title: "Usuarios",
    type: "item",
    icon: <FaUser size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/usuarios"
  },
  {
    id: "formpost",
    title: "Avisos",
    type: "item",
    icon: <FaInfoCircle size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/post"
  },
  {
    id: "Campania",
    title: "Campaña",
    type: "item",
    icon: <FaTags size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/campania"
  },
  {
    id: "Cargar números",
    title: "Cargar Números",
    type: "item",
    icon: <FaRegCalendarTimes size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/cargarnumeros",
  },
  {
    id: "Campania Productos",
    title: "Campaña Productos",
    type: "item",
    icon: <FaRegFlag size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/campaniaproductos"
  },
  {
    id: "FormularioAdicionales",
    title: "Adicionales",
    type: "item",
    icon: <FaPlusCircle size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/FormularioAdicionales"
  },
  {
    id: "FormularioVenta",
    title: "Formulario Venta",
    type: "item",
    icon: <FaAddressCard size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/formulario"
  },
  {
    id: "borrador",
    title: "Borrador",
    type: "item",
    icon: <FaRegBookmark size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/borrador"
  },
  {
    id: "validacionCobertura",
    title: "Validación de cobertura",
    type: "item",
    icon: <FaMarker size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/validacion-cobertura"
  },
  {
    id: "calidad",
    title: "Pendientes por auditar",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/calidad"
  },
  {
    id: "devolucion-backoffice",
    title: "Devoluciones por Backoffice",
    type: "item",
    icon: <FaArrowAltCircleLeft size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/devolucion-backoffice"
  },
  {
    id: "auditadas",
    title: "Auditadas",
    type: "item",
    icon: <FaArrowAltCircleRight size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/auditadas"
  },
  {
    id: "Legalizadas",
    title: "Legalizadas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/legalizadas"
  },
  {
    id: "Archivadas",
    title: "Archivadas",
    type: "item",
    icon: <FaBoxOpen size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/archivadas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO MÓVIL"
  },
  {
    id: "activas",
    title: "Activas",
    type: "item",
    icon: <FaCheckDouble size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/activas"
  },
  {
    id: "rechazadas-abd",
    title: "Rechazadas ABD",
    type: "item",
    icon: <FaWindowClose size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-abd"
  },
  {
    id: "enviadas-abd",
    title: "Enviadas ABD",
    type: "item",
    icon: <FaMailBulk size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/enviadas-abd"
  },
  {
    id: "Exitosas",
    title: "Exitosas",
    type: "item",
    icon: <FaCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/exitosas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO HOGAR"
  },
  {
    id: "agendadas",
    title: "Agendadas",
    type: "item",
    icon: <FaCalendarPlus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/agendadas"
  },
  {
    id: "reprogramadas",
    title: "Reprogramadas",
    type: "item",
    icon: <FaCalendarMinus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/reprogramadas"
  },
  {
    id: "canceladas",
    title: "Canceladas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/canceladas"
  },
  {
    id: "instaladas",
    title: "Instaladas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/instaladas"
  },
  {
    id: "rechazadas-cobertura",
    title: "Rechazadas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-cobertura"
  },
  /* 
  {
    id: "pendientes",
    title: "Pendientes",
    type: "item",
    icon: <FaRegClock size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/pendientes"
  },
  {
    id: "Procesamiento",
    title: "BO Legalización SAC",
    type: "collapse",
    icon: <FaCodeBranch size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "1",
        title: "Pre-legalización",
        type: "item",
        icon: <FaRegCalendarAlt size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/procesamiento",
      },
      {
        id: "2",
        title: "Aprobadas",
        type: "item",
        icon: <FaRegCalendarCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasaprobadas",
      },
      {
        id: "3",
        title: "No Aprobadas",
        type: "item",
        icon: <FaRegCalendarTimes size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasnoaprobadas",
      }
    ]
  } */
]

const navigationAgente = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "token",
    title: "Listado Token",
    type: "item",
    icon: <FaMobileAlt size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/listado-tokens"
  },
  {
    id: "Mis números",	
    title: "Mis números",	
    type: "item",
    icon: <FaRegCalendarTimes size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/numerosCargados",
  },
  {
    id: "FormularioVenta",
    title: "Formulario Venta",
    type: "item",
    icon: <FaAddressCard size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/formulario"
  },
  {
    id: "borrador",
    title: "Borrador",
    type: "item",
    icon: <FaRegBookmark size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/borrador"
  },
  {
    id: "Estado Calidad",
    title: "Pendientes por auditar",
    type: "item",
    icon: <FaRegClock size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/EstadoCalidad"
  },
  {
    id: "Devueltas por Backoffice Agentes",
    title: "Devueltas por Backoffice",
    type: "item",
    icon: <FaArrowAltCircleLeft size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/devolucion-backoffice-agente"
  },
  {
    id: "auditadas",
    title: "Auditadas",
    type: "item",
    icon: <FaArrowAltCircleRight size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/auditadas"
  },
  /* {
    id: "pendientes Agentes",
    title: "Pendientes",
    type: "item",
    icon: <FaRegClock size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/PendientesxAgentes"
  }, */
  {
    type: "groupHeader",
    groupTitle: "SERVICIO MÓVIL"
  },
  {
    id: "rechazadas-abd-agente",
    title: "Rechazadas ABD",
    type: "item",
    icon: <FaWindowClose size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-abd-agente"
  },
  {
    id: "enviadas-abd-agente",
    title: "Enviadas ABD",
    type: "item",
    icon: <FaMailBulk size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/enviadas-abd-agente"
  },
  {
    id: "exitosas-agente",
    title: "Exitosas",
    type: "item",
    icon: <FaCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/exitosas-agente"
  },
  {
    id: "activas-agente",
    title: "Activas",
    type: "item",
    icon: <FaCheckDouble size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/activas-agente"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO HOGAR"
  },
  {
    id: "agendadas-agente",
    title: "Agendadas",
    type: "item",
    icon: <FaCalendarPlus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/agendadas-agente"
  },
  {
    id: "reprogramadas-agente",
    title: "Reprogramadas",
    type: "item",
    icon: <FaCalendarMinus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/reprogramadas-agente"
  },
  {
    id: "canceladas-agente",
    title: "Canceladas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/canceladas-agente"
  },
  {
    id: "instaladas-agente",
    title: "Instaladas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/instaladas-agente"
  },
]

const navigationAgenteExterno = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  /* {
    id: "token",
    title: "Listado Token",
    type: "item",
    icon: <FaMobileAlt size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/listado-tokens"
  }, */
  {
    id: "Mis números",	
    title: "Mis números",	
    type: "item",
    icon: <FaRegCalendarTimes size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/numerosCargados",
  },
  {
    id: "FormularioVenta",
    title: "Formulario Venta",
    type: "item",
    icon: <FaAddressCard size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/formulario"
  },
  {
    id: "borrador",
    title: "Borrador",
    type: "item",
    icon: <FaRegBookmark size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/borrador"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO MÓVIL"
  },
  {
    id: "activas-agente",
    title: "Activas",
    type: "item",
    icon: <FaCheckDouble size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/activas-agente"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO HOGAR"
  },
  {
    id: "instaladas-agente",
    title: "Instaladas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/instaladas-agente"
  },
  {
    id: "rechazadas-cobertura-agente",
    title: "Rechazadas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-cobertura-agente"
  },
  /* {
    id: "pendientes Agentes",
    title: "Pendientes",
    type: "item",
    icon: <FaRegClock size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/PendientesxAgentes"
  }, */
 /*  {
    id: "Estado Calidad",
    title: "BO Digitación y Legalización",
    type: "item",
    icon: <FaRegClock size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/EstadoCalidad"
  } */
]

const navigationProcesador = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "auditadas",
    title: "Auditadas",
    type: "item",
    icon: <FaArrowAltCircleRight size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/auditadas"
  },
  {
    id: "devolucion-backoffice",
    title: "Devoluciones por Backoffice",
    type: "item",
    icon: <FaArrowAltCircleLeft size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/devolucion-backoffice"
  },
  {
    id: "Legalizadas",
    title: "Legalizadas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/legalizadas"
  },
  {
    id: "Archivadas",
    title: "Archivadas",
    type: "item",
    icon: <FaBoxOpen size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/archivadas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO MÓVIL"
  },
  {
    id: "activas",
    title: "Activas",
    type: "item",
    icon: <FaCheckDouble size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/activas"
  },
  {
    id: "rechazadas-abd",
    title: "Rechazadas ABD",
    type: "item",
    icon: <FaWindowClose size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-abd"
  },
  {
    id: "enviadas-abd",
    title: "Enviadas ABD",
    type: "item",
    icon: <FaMailBulk size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/enviadas-abd"
  },
  {
    id: "Exitosas",
    title: "Exitosas",
    type: "item",
    icon: <FaCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/exitosas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO HOGAR"
  },
  {
    id: "agendadas",
    title: "Agendadas",
    type: "item",
    icon: <FaCalendarPlus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/agendadas"
  },
  {
    id: "reprogramadas",
    title: "Reprogramadas",
    type: "item",
    icon: <FaCalendarMinus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/reprogramadas"
  },
  {
    id: "canceladas",
    title: "Canceladas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/canceladas"
  },
  {
    id: "instaladas",
    title: "Instaladas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/instaladas"
  },
  /* {
    id: "Procesamiento",
    title: "BO Legalización SAC",
    type: "collapse",
    icon: <FaCodeBranch size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "1",
        title: "Pre-legalización",
        type: "item",
        icon: <FaRegCalendarAlt size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/procesamiento",
      },
      {
        id: "2",
        title: "Aprobadas",
        type: "item",
        icon: <FaRegCalendarCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasaprobadas",
      },
      {
        id: "3",
        title: "No Aprobadas",
        type: "item",
        icon: <FaRegCalendarTimes size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasnoaprobadas",
      }
    ]
  } */
]

const navigationCalidad = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "token",
    title: "Listado Token",
    type: "item",
    icon: <FaMobileAlt size={size} />,
    bagde: "primary",
    badgeText: <Metricas badgeText="Tokens" />,
    permissions: ["admin", "editor"],
    navLink: "/listado-tokens"
  },
  {
    id: "validacionCobertura",
    title: "Validación de cobertura",
    type: "item",
    icon: <FaWifi size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/validacion-cobertura"
  },
  {
    id: "calidad",
    title: "Pendientes por auditar",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/calidad"
  },
  {
    id: "devolucion-backoffice",
    title: "Devoluciones por Backoffice",
    type: "item",
    icon: <FaArrowAltCircleLeft size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/devolucion-backoffice"
  },
  {
    id: "auditadas",
    title: "Auditadas",
    type: "item",
    icon: <FaArrowAltCircleRight size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/auditadas"
  },
  {
    id: "Legalizadas",
    title: "Legalizadas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/legalizadas"
  },
  {
    id: "Archivadas",
    title: "Archivadas",
    type: "item",
    icon: <FaBoxOpen size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/archivadas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO MÓVIL"
  },
  {
    id: "activas",
    title: "Activas",
    type: "item",
    icon: <FaCheckDouble size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/activas"
  },
  {
    id: "rechazadas-abd",
    title: "Rechazadas ABD",
    type: "item",
    icon: <FaWindowClose size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-abd"
  },
  {
    id: "enviadas-abd",
    title: "Enviadas ABD",
    type: "item",
    icon: <FaMailBulk size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/enviadas-abd"
  },
  {
    id: "Exitosas",
    title: "Exitosas",
    type: "item",
    icon: <FaCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/exitosas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO HOGAR"
  },
  {
    id: "agendadas",
    title: "Agendadas",
    type: "item",
    icon: <FaCalendarPlus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/agendadas"
  },
  {
    id: "reprogramadas",
    title: "Reprogramadas",
    type: "item",
    icon: <FaCalendarMinus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/reprogramadas"
  },
  {
    id: "canceladas",
    title: "Canceladas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/canceladas"
  },
  {
    id: "instaladas",
    title: "Instaladas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/instaladas"
  },
  {
    id: "rechazadas-cobertura",
    title: "Rechazadas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-cobertura"
  },
]

const navigationBackOfficeExterno = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "token",
    title: "Listado Token",
    type: "item",
    icon: <FaMobileAlt size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/listado-tokens"
  },
  {
    id: "Mis números",	
    title: "Mis números",	
    type: "item",
    icon: <FaRegCalendarTimes size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/numerosCargados",
  },
  {
    id: "FormularioVenta",
    title: "Formulario Venta",
    type: "item",
    icon: <FaAddressCard size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/formulario"
  },
  {
    id: "borrador",
    title: "Borrador",
    type: "item",
    icon: <FaRegBookmark size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/borrador"
  },
  {
    id: "pendientes Agentes",
    title: "Pendientes",
    type: "item",
    icon: <FaRegClock size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/PendientesxAgentes"
  },
  {
    id: "Estado Calidad",
    title: "BO Digitación y Legalización",
    type: "item",
    icon: <FaRegClock size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/EstadoCalidad"
  },
  {
    id: "calidad",
    title: "Verificación",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/calidadExterno"
  }
]

const navigationSupervisor = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "Campania Productos",
    title: "Campaña Productos",
    type: "item",
    icon: <FaRegFlag size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/campaniaproductos"
  },
  {
    id: "FormularioAdicionales",
    title: "Adicionales",
    type: "item",
    icon: <FaPlusCircle size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/FormularioAdicionales"
  },
  {
    id: "calidad",
    title: "Pendientes por auditar",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/calidad"
  },
  {
    id: "devolucion-backoffice",
    title: "Devoluciones por Backoffice",
    type: "item",
    icon: <FaArrowAltCircleLeft size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/devolucion-backoffice"
  },
  {
    id: "auditadas",
    title: "Auditadas",
    type: "item",
    icon: <FaArrowAltCircleRight size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/auditadas"
  },
  {
    id: "Legalizadas",
    title: "Legalizadas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/legalizadas"
  },
  {
    id: "Archivadas",
    title: "Archivadas",
    type: "item",
    icon: <FaBoxOpen size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/archivadas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO MÓVIL"
  },
  {
    id: "activas",
    title: "Activas",
    type: "item",
    icon: <FaCheckDouble size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/activas"
  },
  {
    id: "rechazadas-abd",
    title: "Rechazadas ABD",
    type: "item",
    icon: <FaWindowClose size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-abd"
  },
  {
    id: "enviadas-abd",
    title: "Enviadas ABD",
    type: "item",
    icon: <FaMailBulk size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/enviadas-abd"
  },
  {
    id: "Exitosas",
    title: "Exitosas",
    type: "item",
    icon: <FaCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/exitosas"
  },
  {
    type: "groupHeader",
    groupTitle: "SERVICIO HOGAR"
  },
  {
    id: "agendadas",
    title: "Agendadas",
    type: "item",
    icon: <FaCalendarPlus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/agendadas"
  },
  {
    id: "reprogramadas",
    title: "Reprogramadas",
    type: "item",
    icon: <FaCalendarMinus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/reprogramadas"
  },
  {
    id: "canceladas",
    title: "Canceladas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/canceladas"
  },
  {
    id: "instaladas",
    title: "Instaladas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/instaladas"
  },
  {
    id: "rechazadas-cobertura",
    title: "Rechazadas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-cobertura"
  },

  /* {
    id: "Procesamiento",
    title: "BO Legalización SAC",
    type: "collapse",
    icon: <FaCodeBranch size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "1",
        title: "Pre-legalización",
        type: "item",
        icon: <FaRegCalendarAlt size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/procesamiento",
      },
      {
        id: "2",
        title: "Aprobadas",
        type: "item",
        icon: <FaRegCalendarCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasaprobadas",
      },
      {
        id: "3",
        title: "No Aprobadas",
        type: "item",
        icon: <FaRegCalendarTimes size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasnoaprobadas",
      }
    ]
  } */
]

const navigationSupervisorExterno = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "usuarios",
    title: "Usuarios",
    type: "item",
    icon: <FaUser size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/usuarios"
  },
  {
    id: "Verificacion",
    title: "Verificación",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/calidadExterno"
  },
  /* {
    id: "calidad",
    title: "Pendientes por auditar",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/calidad"
  },
  {
    id: "devolucion-backoffice",
    title: "Devoluciones por Backoffice",
    type: "item",
    icon: <FaArrowAltCircleLeft size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/devolucion-backoffice"
  },
  {
    id: "auditadas",
    title: "Auditadas",
    type: "item",
    icon: <FaArrowAltCircleRight size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/auditadas"
  }, */
  {
    id: "Legalizadas",
    title: "Instaladas",
    type: "item",
    icon: <FaCalendarCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/legalizadas"
  },
  {
    id: "instaladas",
    title: "Aprobadas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/instaladas"
  },
  {
    id: "agendadas",
    title: "Agendadas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/agendadas"
  },
  {
    id: "reprogramadas",
    title: "Reprogramadas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/reprogramadas"
  },
  {
    id: "canceladas",
    title: "Canceladas",
    type: "item",
    icon: <FaClipboardList size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/canceladas"
  },
  
  {
    id: "rechazadas-cobertura",
    title: "Rechazadas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-cobertura"
  },
  /* {
    id: "Archivadas",
    title: "Archivadas",
    type: "item",
    icon: <FaBoxOpen size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/archivadas"
  }, */
 /*  {
    type: "groupHeader",
    groupTitle: "SERVICIO MÓVIL"
  },
  {
    id: "activas",
    title: "Activas",
    type: "item",
    icon: <FaCheckDouble size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/activas"
  },
  {
    id: "rechazadas-abd",
    title: "Rechazadas ABD",
    type: "item",
    icon: <FaWindowClose size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/rechazadas-abd"
  },
  {
    id: "enviadas-abd",
    title: "Enviadas ABD",
    type: "item",
    icon: <FaMailBulk size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/enviadas-abd"
  },
  {
    id: "Exitosas",
    title: "Exitosas",
    type: "item",
    icon: <FaCheck size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/exitosas"
  }, */
 /*  {
    type: "groupHeader",
    groupTitle: "SERVICIO HOGAR"
  }, */
  /* {
    id: "agendadas",
    title: "Agendadas",
    type: "item",
    icon: <FaCalendarPlus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/agendadas"
  },
  {
    id: "reprogramadas",
    title: "Reprogramadas",
    type: "item",
    icon: <FaCalendarMinus size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/reprogramadas"
  },
  {
    id: "canceladas",
    title: "Canceladas",
    type: "item",
    icon: <FaCalendarTimes size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/canceladas"
  }, */

  /* {
    id: "Procesamiento",
    title: "BO Legalización SAC",
    type: "collapse",
    icon: <FaCodeBranch size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "1",
        title: "Pre-legalización",
        type: "item",
        icon: <FaRegCalendarAlt size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/procesamiento",
      },
      {
        id: "2",
        title: "Aprobadas",
        type: "item",
        icon: <FaRegCalendarCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasaprobadas",
      },
      {
        id: "3",
        title: "No Aprobadas",
        type: "item",
        icon: <FaRegCalendarTimes size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ventasnoaprobadas",
      }
    ]
  } */
]


const navigationConfig =
    user?.profile === 7 ? navigation : //SuperAdmin ✔
      user?.profile === 104 ? navigationSupervisor : //Supervisor
        user?.profile === 118 ? navigationAgente : //Agente ✔
          user?.profile === 211 ? navigationProcesador : //Procesador ✔
            user?.profile === 106 ? navigation : //Soporte ✔
              user?.profile === 265 ? navigationCalidad : //Calidad ✔
                user?.profile === 505 ? navigationAgenteExterno : //Agente externo ✔
                  user?.profile === 506 ? navigationBackOfficeExterno : //BackOffice externo ✔
                    user?.profile === 510 ? navigationSupervisorExterno : //Supervisor externo ✔
          []

export default navigationConfig
